import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export function decimalValidator(decimal: number = 2): ValidatorFn {
  return (control: AbstractControl<number>): ValidationErrors | null => {
    const value = control.value;
    if (typeof value !== 'number') { return null; }
    if (value === null || value === undefined) return null;
    //  zero decimals
    if (Math.floor(value.valueOf()) === value.valueOf()) return null;
    const decimalLength = value.toString().split('.')[1].length || 0;
    return decimalLength <= decimal ? null : { decimal };
  };
}
